import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const SegmentsWarningBannerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 16px;
    line-height: 20px;
    padding: 16px 32px;
    background: ${colorsPalettes.yellow[200]};
`;

export const SegmentsWarningBannerContent = styled.div`
    text-align: center;
`;

export const SegmentsWarningBannerContentPrimary = styled.span`
    font-weight: 500;
`;

export const SegmentsWarningBannerContentSecondary = styled.span`
    font-weight: 300;
    margin-left: 0.5em;
`;
